import React, { useEffect, useRef, useContext, useState } from "react";
import { UserDataContext } from "../../App";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import CheckboxValidatorElement from "../../components/forms/CheckboxValidatorElement";
import { InputAdornment, Button, Grid, Box, MenuItem, Autocomplete, Typography, useMediaQuery } from "@mui/material";
import { ProfileGrey, Wallet, PhoneNumber, Warning, Message, TelegramField, Phone, WhatsApp } from "../../assets/images/icons";
import { checkFieldCondition, getText } from "../../libs/utils";
import Notice from "./Notice";
import PSIcon from "../../components/PSIcon";
import { styled, useTheme } from "@mui/material/styles"
import { luhnCheck, formatCardNumber } from "../../libs/utils";
import PromtAML from "./PromtAML";

const MyBox = styled(Box)(({ theme }) => ({
  ".line-breaker": {
    display: 'none'
  },
  "&.order-form": {
    [theme.breakpoints.only('md')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ".form-field, .notice-field, .button-field": {
        width: 'calc(50% - 8px)',
      },
      ".line-breaker": {
        flexBasis: '100%',
        height: 0,
        display: 'block'
      }
    }
  },
  "&.refs-payout": {
    [theme.breakpoints.only('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ".form-field:nth-of-type(1), .form-field:nth-of-type(2)": {
        width: 'calc(50% - 8px)',
        margin: '0'
      },
      ".form-field, .notice-field, .button-field": {
        width: '100%',
      }
    }
  },
  "&.add-wallet": {
    [theme.breakpoints.only('md')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ".form-field, .notice-field": {
        width: 'calc(33.3% - 8px)',
      },
      ".button-field": {
        alignItems: 'flex-start',
        width: 'calc(33.3% - 8px)',
        marginTop: '6px',
        ".MuiButtonBase-root": {
          padding: '16px 32px 16px'
        }
      }
    },
    [theme.breakpoints.only('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ".form-field, .notice-field, .button-field": {
        width: 'calc(50% - 8px)',
      },
      ".button-field": {
        alignItems: 'flex-start',
        width: 'calc(50% - 8px)',
        marginTop: '6px',
        ".MuiButtonBase-root": {
          padding: '16px 32px 16px'
        }
      }
    }
  }
}))

const MyMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  fontSize: '16px',
  gap: 12
}))

const OrderFormFields = ({
  className,
  additionalField,
  fields = [],
  systemsType,
  toSystem,
  notices = [],
  handleSubmitOrder,
  formData,
  setFormData,
  button = getText('ocrEzSubmit'),
  buttonSx = {},
  buttonLeftCol = true,
  loading = false,
  toWallets = [],
  fromWallets = [],
  directKey = "",
}) => {

  const userData = useContext(UserDataContext);
  const [availablePaymentNumbers, setAvailablePaymentNumbers] = useState([]);
  const [rulePrompt, setRulePrompt] = useState(false);
  let fieldRefs = useRef({});
  let formDataRef = useRef(formData);
  var sbpCheck = null;
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    ValidatorForm.addValidationRule("isTruthy", (value) => value);
    ValidatorForm.addValidationRule('isLuhn', (value) => {
      if (luhnCheck(value ? value : '')) {
        return true;
      }
      return false;
    });

    ValidatorForm.addValidationRule('isWhatsapp', (value) => {
      if (!formDataRef.current['telegram'] && !formDataRef.current['whatsapp']) {
        return false;
      }
      return true;
    });

    return () => {
      ValidatorForm.removeValidationRule('isLuhn');
      ValidatorForm.removeValidationRule('isTruthy');
      ValidatorForm.removeValidationRule('isWhatsapp');
    };
  }, []);

  // remove fields by spb button condition
  var filteredList = fields.filter((input) => {

    if (input.id === "useAlternateNumber" && input.type !== "hidden") {
      sbpCheck = input;
      return false;
    }

    if (input.name === "clientEmail" && userData.token) {
      return false
    }

    if (!checkFieldCondition(input, formData)) {
      return false;
    }

    if (input?.type === "hidden") {
      return false
    }

    fieldRefs.current[input.name] = '';
    return true;
  });

  const checkNotices = () => {
    let checked = false;
    notices.map(item => {
      if (item) checked = true;
    })
    return checked;
  }

  // let existingFields = [];
  // ['to[number]', 'to[alternateNumber]', 'number', 'alternateNumber'].forEach((name) => {
  //   if(name in fieldRefs.current){
  //     existingFields.push(name);
  //   }
  // });

  // add spb button to the end of field
  const addSpbButton = ({ name, id }) => {
    if (sbpCheck && ['to[number]', 'to[alternateNumber]', 'alternateNumber'].includes(name) || sbpCheck && id == 'number' && name == 'number') {
      return (
        <Button
          variant=""
          className="endAdornmentButton"
          name={sbpCheck.name}
          onClick={() => {
            setFormData({
              ...formData,
              [sbpCheck.name]: formData[sbpCheck.name] ? 0 : 1,
              ['to[number]']: '',
              ['to[alternateNumber]']: '',
              ['number']: '',
              ['alternateNumber']: '',
            });
            fieldRefs.current['to[number]'] && fieldRefs.current['to[number]'].makeValid();
            fieldRefs.current['to[alternateNumber]'] && fieldRefs.current['to[alternateNumber]'].makeValid();
            fieldRefs.current['number'] && fieldRefs.current['number'].makeValid();
            fieldRefs.current['alternateNumber'] && fieldRefs.current['alternateNumber'].makeValid();
          }}
        >
          {['to[number]', 'number'].includes(name) && (
            isXS ? getText('sbp') : getText('sbpTooltipPhone2')
          )}
          {['to[alternateNumber]', 'alternateNumber'].includes(name) && (
            isXS ? getText('sbpTooltipCard') : getText('sbpTooltipCard2')
          )}
        </Button>
      );
    }
  };

  const handleBlur = (event, isCard = false) => {
    const fixedEventData = { ...event };

    isCard
      ? fixedEventData.target.value = event.target.value.replaceAll(' ', '')
      : fixedEventData.target.value = event.target.value.trim();

    // my kostyl - when field is empty and has custom validation any way shows error
    if (['number', 'req'].includes(fixedEventData.target.id) && fixedEventData.target.value === '') {
      fieldRefs.current[event.target.name].makeValid();
    } else {
      fieldRefs.current[fixedEventData.target.name].validate(fixedEventData.target.value);
    }
  }

  const handleAutocompleteOptionClick = (option) => {
    if (option) {
      const { name, value, fieldName, paymentNumbers } = option;
      let formFieldsVals = {
        ...formData,
        [fieldName]: value,
        ...(name && { [fieldName.replace('number', 'fio')]: name }),
      };
      fieldRefs.current[fieldName].makeValid();
      paymentNumbers?.length && setAvailablePaymentNumbers(paymentNumbers);
      setFormData(formFieldsVals);

    }
  }

  const handleAutocompleteChange = (event, value, isCard = false) => {
    if (event.target.name) {
      let fixedValue = value;
      if (isCard) {
        fixedValue = fixedValue.replaceAll(' ', '').replace(/\D/g, '');
      }
      else if (event.target.placeholder === 'Номер телефона' || event.target.placeholder === 'Phone number') {
        fixedValue = fixedValue.replace(/[-() ]/g, '');
      }
      setFormData({
        ...formData,
        [event.target.name]: fixedValue,
      })
    }
  }

  const handleSelectChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    if (event.target.value) {
      fieldRefs.current[event.target.name].makeValid();
    }
  }

  const handleChange = (event, isCard = false) => {
    let fixedValue = event.target.value;
    if (isCard) {
      fixedValue = fixedValue.replaceAll(' ', '').replace(/\D/g, '');
    } else if (event.target.placeholder === 'Номер телефона' || event.target.placeholder === 'Phone number') {
      fixedValue = fixedValue.replace(/[-() ]/g, '');
    }

    setFormData({
      ...formData,
      [event.target.name]: fixedValue,
    })
  }

  const handleChangeCard = (e, input, inputProps) => {
    if (input.rules.includes('isLuhn')) {
      const caretStart = e.target.selectionStart;
      const caretEnd = e.target.selectionEnd;
      let spaces = 0;
      if (e.nativeEvent.inputType == 'insertText') {
        if (e.target.value.length > e.target.selectionStart) {
          spaces = e.target.value[e.target.selectionStart] == ' ' ? 1 : 0;
        } else {
          spaces = 1;
        }
      }
      // update the state and reset the caret
      setTimeout(() => e.target.setSelectionRange(caretStart + spaces, caretEnd + spaces), 0)
    }
    inputProps.onChange(e);
  }

  const preSubmitCheck = (submitSource = 'default') => {
    if (toSystem?.isExternal) {
      handleSubmitOrder();
      return;
    }

    const fromType = systemsType.from;
    const toType = systemsType.to;

    if (submitSource === 'default') {
      fromType === 0
        ? setRulePrompt('fromBank')
        : toType === 404 // disabled toBank
          ? setRulePrompt('toBank')
          : (fromType === 1 || toType === 1)
            ? setRulePrompt('aml')
            : handleSubmitOrder();
    } else if (submitSource === 'fromBank' || submitSource === 'toBank') {
      (fromType === 1 || toType === 1)
        ? setRulePrompt('aml')
        : handleSubmitOrder();
    } else if (submitSource === 'aml') {
      handleSubmitOrder();
    }

  }

  return (
    <ValidatorForm
      onSubmit={() => { preSubmitCheck(); }}
      instantValidate={false}
      key={directKey}
    >
      <MyBox className={className}>

        {additionalField}

        {filteredList.map((input, key) => {

          if (input.name === "clientEmail") {
            input.rules = ['isEmail', 'required']
            input.messages[1] = getText("reqiuredField")
          }

          if (input.name === 'whatsapp') {
            input.rules.push('isWhatsapp')
            input.messages.push(getText("whatsappRequired"))
          }
          // select field
          if (input.items) {
            return <Box
              key={key}
              className="form-field"
            >
              <SelectValidator
                ref={el => fieldRefs.current[input.name] = el}
                fullWidth
                validators={input.rules}
                errorMessages={input.messages}
                id={input.id}
                name={input.name}
                onChange={handleSelectChange}
                value={formData[input.name] || ""}
                sx={{ margin: '6px 0' }}
                SelectProps={{
                  displayEmpty: true,
                  className: 'order-form',
                  MenuProps: {
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                  }
                }}
              >
                <MyMenuItem value="">
                  <PSIcon name={'visamastercard'} width={24} height={24} margin="0" /> <Box className="empty-option">{getText('chooseBank')}</Box>
                </MyMenuItem>

                {input.items.map((row, key) => (
                  <MyMenuItem value={row.id} key={key}>
                    {row.className && <PSIcon name={row.className.toLowerCase()} width={24} height={24} margin="0" />} {row.name}
                  </MyMenuItem>
                ))}
              </SelectValidator>
            </Box>
            // wallet field
          } else if (input.name === 'to[number]' || input.name === 'from[number]' || input.id === "number" || input.id === "req") {
            return (
              <Autocomplete
                className="form-field"
                key={key}
                id={input.id}
                freeSolo={true}
                disablePortal
                options={input.name === 'from[number]'
                  ? fromWallets.map(({ fio, req, availablePaymentNumbers }) => ({ paymentNumbers: availablePaymentNumbers, name: fio, value: req, fieldName: input.name, label: input.rules.includes('isLuhn') ? formatCardNumber(req) : req }))
                  : toWallets.map(({ fio, req, availablePaymentNumbers }) => ({ paymentNumbers: availablePaymentNumbers, name: fio, value: req, fieldName: input.name, label: input.rules.includes('isLuhn') ? formatCardNumber(req) : req }))
                }
                onChange={(event, value) => handleAutocompleteOptionClick(value)} // click on card number to fill user name
                onInputChange={(event, inputValue) => handleAutocompleteChange(event, inputValue, input.rules.includes('isLuhn'))}
                onBlur={(event) => handleBlur(event, input.rules.includes('isLuhn'))}
                componentsProps={{
                  popper: {
                    placement: 'bottom',
                    modifiers: [
                      { name: 'flip', enabled: false }
                    ],
                  }
                }}
                renderInput={({ inputProps, ...params }) => (
                  <TextValidator
                    {...params}
                    ref={el => fieldRefs.current[input.name] = el}
                    fullWidth
                    type="text"
                    validators={input.rules}
                    errorMessages={input.messages}
                    name={input.name}
                    placeholder={input.label}
                    variant="standard"
                    value={formData[input.name]} // value for validation
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start"><Wallet /></InputAdornment>
                      ),
                      endAdornment: addSpbButton(input),
                    }}
                    inputProps={{
                      ...inputProps,
                      inputMode: input.rules.includes('isLuhn') ? 'numeric' : 'text',
                      autoComplete: (input.name === 'from[number]' && fromWallets.length > 0) || (input.name === 'to[number]' && toWallets.length > 0) ? 'off' : 'on',
                      onChange: (e) => handleChangeCard(e, input, inputProps),
                      value: input.rules.includes('isLuhn') ? formatCardNumber(formData[input.name]) || '' : formData[input.name] || '' // value for display, not for validation
                    }}
                  />
                )}
              />
            )
          }
          else if (input.name === 'to[paymentNumber]' || input.name === 'from[paymentNumber]') {
            return (
              <Autocomplete
                className="form-field"
                key={key}
                id={input.id}
                freeSolo={true}
                disablePortal
                options={availablePaymentNumbers.map(({ req }) => ({ value: req, fieldName: input.name, label: req }))
                }
                onChange={(event, value) => handleAutocompleteOptionClick(value)} // click on card number to fill user name
                onInputChange={(event, inputValue) => handleAutocompleteChange(event, inputValue, false)}
                onBlur={(event) => handleBlur(event, false)}
                componentsProps={{
                  popper: {
                    placement: 'bottom',
                    modifiers: [
                      { name: 'flip', enabled: false }
                    ],
                  }
                }}
                renderInput={({ inputProps, ...params }) => (
                  <TextValidator
                    {...params}
                    ref={el => fieldRefs.current[input.name] = el}
                    fullWidth
                    type="text"
                    validators={input.rules}
                    errorMessages={input.messages}
                    name={input.name}
                    placeholder={input.label}
                    variant="standard"
                    value={formData[input.name]} // value for validation
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start"><PhoneNumber /></InputAdornment>
                      ),
                      endAdornment: addSpbButton(input),
                    }}
                    inputProps={{
                      ...inputProps,
                      inputMode: 'text',
                      autoComplete: availablePaymentNumbers.length > 0 ? 'off' : 'on',
                      onChange: (e) => handleChangeCard(e, input, inputProps),
                      value: formData[input.name] || '' // value for display, not for validation
                    }}
                  />
                )}
              />
            )
          }
          else {
            // text field
            return <Box key={key} className="form-field">
              <TextValidator
                ref={el => fieldRefs.current[input.name] = el}
                type={'text'}
                fullWidth
                validators={input.rules}
                errorMessages={input.messages}
                id={input.id}
                name={input.name}
                onBlur={(event) => handleBlur(event, input.rules.includes('isLuhn'))}
                onChange={(event) => handleChange(event, input.rules.includes('isLuhn'))}
                value={formData[input.name] || ''}
                placeholder={input.label}
                variant="standard"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {input.id === "clientEmail" && <Message />}
                      {input.id === "fio" && <ProfileGrey />}
                      {input.id === "alternateNumber" && <PhoneNumber />}
                      {input.id === "paymentNumber" && <PhoneNumber />}
                      {input.id === "telegram" && <TelegramField />}
                      {input.id === "whatsapp" && <WhatsApp />}
                    </InputAdornment>
                  ),
                  endAdornment: addSpbButton(input),
                }}
                inputProps={{
                  inputMode: input.id === "alternateNumber"
                    ? 'tel'
                    : input.id === "clientEmail" ? 'email' : 'text',
                }}
              />
              {input.name === 'to[alternateNumber]' && <Typography sx={{ padding: '6px 0' }} variant="greyCaption" component="div">{getText('willPaySbp')}</Typography>}
            </Box>
          }
        })}

        {filteredList.length == 0 && <Box sx={{ fontWeight: 600, margin: { xs: '25px 0 40px', sm: '-5px 0 40px' } }}>{getText('noNeedData')}</Box>}

        {checkNotices() && <>
          <span className="line-breaker"></span>
          <Notice
            type="warning"
            icon={<Warning />}
          >
            {notices.map((notice, key) => notice && <p key={key} dangerouslySetInnerHTML={{ __html: notice }}></p>)}
          </Notice>
        </>}

        <Grid
          className="button-field"
          container
          alignItems="center"
          sx={{ marginTop: className == 'order-form' ? ['9px', '15px', '9px', '15px'] : ['12px', '9px', '12px', '12px'] }}
        >
          {/* if left col is html element */}
          {React.isValidElement(buttonLeftCol) ? <>
            <Grid item lg={6} md={12} sm={6} xs={12}>
              {buttonLeftCol}
            </Grid>
            <Grid item lg={6} md={12} sm={6} xs={12}>
              <Button
                variant="contained"
                fullWidth
                size="large"
                type="submit"
                disabled={loading}
                sx={{ marginTop: { xs: '20px', sm: 0, md: '20px', lg: 0 }, ...buttonSx }}
              >
                {button}
              </Button>
            </Grid>
          </> : <>
            {buttonLeftCol ? <>
              <Grid item lg={6} md={12} sm={6} xs={12} sx={{
                padding: { lg: '0 20px 0 0', md: '0 0 18px', sm: '0 20px 0 0', xs: '12px 0 18px' },
                gap: '8px',
                display: 'flex',
                flexDirection: 'column',
              }}>
                <CheckboxValidatorElement

                  name={"terms"}
                  ref={el => fieldRefs.current['terms'] = el}
                  validators={["isTruthy"]}
                  checked={formData.terms}
                  value={formData.terms}
                  onChange={(event) => {
                    setFormData({ ...formData, terms: !formData.terms });
                    event.target.checked && fieldRefs.current['terms'].makeValid();
                  }}
                  label={
                    <>
                      {getText('orderAgree1')}{" "}
                      <a href="/rules" target="_blank">{getText("orderAgree2")}</a>
                    </>
                  }
                />
                <CheckboxValidatorElement
                  name={"third"}
                  ref={el => fieldRefs.current['third'] = el}
                  validators={["isTruthy"]}
                  checked={formData.third}
                  value={formData.third}
                  onChange={(event) => {
                    setFormData({ ...formData, third: !formData.third });
                    event.target.checked && fieldRefs.current['third'].makeValid();
                  }}
                  label={
                    <>
                      {getText('orderAgreeThird')}{" "}

                    </>
                  }
                />
              </Grid>
              <Grid item lg={6} md={12} sm={6} xs={12}>

                <Button variant="contained" fullWidth size="large" type="submit" disabled={loading} sx={buttonSx}>{button}</Button>

              </Grid>
            </> : <>
              <Grid item xs={12}>

                <Button variant="contained" fullWidth size="large" type="submit" disabled={loading} sx={buttonSx}>{button}</Button>

              </Grid>
            </>}
          </>}
        </Grid>

      </MyBox>
      <PromtAML
        open={rulePrompt}
        onDecline={() => setRulePrompt(false)}
        onAccept={() => preSubmitCheck(rulePrompt)}
        loading={loading}
      />
    </ValidatorForm>
  );
};

export default OrderFormFields;
